// extracted by mini-css-extract-plugin
module.exports = {"cont":"newsAndEvents-module--cont--1ouRK","img":"newsAndEvents-module--img--3S7gk","textCont":"newsAndEvents-module--textCont--xXein"};